export default __webpack_public_path__ + "static/media/owl-logo@3x.43605f39.png";